/**
 *  The bound element will only allow input which validates against the
 *  specified mask.
 */

ko.bindingHandlers.valueMask = {
	init : function ( element, valueAccessor, allBindings, viewModel, bindingContext ) {
		var mask = ko.unwrap( valueAccessor() );

		if ( mask ) {
			$( element ).mask( mask, {
				onChange: function ( value ) {
					/* update the observable after the mask has changed the value, in
						* case knockout does not pick up the change to the DOM event, which
						* can happen if the input is entered too fast such as by holding down
						* a key
						*/

					//bindingContext.$root.addAppointmentTicket[viewModel.name](value);
				},
				translation: {
					'*': {
						pattern: /[2-9]/
					},
					'Z': {
						pattern: /1/,
						optional: true
					}
				}
			});

		}
	},
	update : function ( element, valueAccessor, allBindings, viewModel, bindingContext ) {
		var mask = ko.unwrap( valueAccessor() );

		if ( mask ) {
			$( element ).mask( mask, {
				onChange: function ( value ) {
					/* update the observable after the mask has changed the value, in
						* case knockout does not pick up the change to the DOM event, which
						* can happen if the input is entered too fast such as by holding down
						* a key
						*/

					//bindingContext.$root.addAppointmentTicket[viewModel.name](value);
				},
				translation: {
					'*': {
						pattern: /[2-9]/
					},
					'Z': {
						pattern: /1/,
						optional: true
					}
				}
			});

		}

	}
};

ko.bindingHandlers.datepicker = {
  init: function(
    element,
    valueAccessor,
    allBindings,
    viewModel,
    bindingContext
  ) {
    var value = ko.unwrap(valueAccessor);
    // Convert the input element to a JQuery UI DatePicker
    $(element).val(value);
    $(element).datepicker({
      dateFormat: $.datepicker.ISO_8601
    });
  },
  update: function(
    element,
    valueAccessors,
    allBindings,
    viewModel,
    bindingContext
  ) {}
};

ko.bindingHandlers.languageName = {
	init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			// This will be called when the binding is first applied to an element
			// Set up any initial state, event handlers, etc. here
	},
	update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			// This will be called once when the binding is first applied to an element,
			// and again whenever any observables/computeds that are accessed change
			// Update the DOM element based on the supplied values here.
			var messages = bindingContext.$root.messagesWS
			var languageName = messages.languageName(ko.unwrap(valueAccessor()))
			element.innerHTML = languageName; 
	}
};
